export default {
  init() {


  },
  finalize() {


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateInfos.js